import React from 'react';

const About = () => {
    return (
        <div>
            <h2 className="h2 mt-3">About</h2>
        </div>
    );
};

export default About;